import { render, staticRenderFns } from "./ZeroxaPOAPModule.vue?vue&type=template&id=5b95b8f0&"
import script from "./ZeroxaPOAPModule.vue?vue&type=script&lang=js&"
export * from "./ZeroxaPOAPModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports